// In eine Funktion gekapselt: die Datei wird von mehreren Sections derselben
// Seite eingebunden. Eine Klassendeklaration auf oberster Ebene würfe ab dem
// zweiten Laden „Identifier has already been declared". customElements.define
// ist ohnehin geschützt; so bleibt auch die Klasse selbst lokal.
(() => {
/**
 * <lo-disclosure> — sanftes Auf- und Zuklappen für <details>
 * ==========================================================
 *
 * Ersetzt das <gp-accordion> von GemPages in der Section Feature-Cards.
 *
 * Wichtiger Unterschied zum Original: dort war der Aufklapper ein <div> mit
 * Klick-Handler — ohne JavaScript ließ sich der Text gar nicht öffnen, und
 * mit Tastatur schon gar nicht. Hier steckt der Inhalt in einem echten
 * <details>. Ohne dieses Skript klappt es schlicht ohne Animation auf.
 *
 * Übernommen aus dem Original: 500ms, Kurve cubic-bezier(.4,0,.2,1), und das
 * Vorgehen beim Schließen (Höhe festschreiben, Reflow erzwingen, auf 0).
 *
 * Verwendung:
 *   <lo-disclosure>
 *     <details>
 *       <summary>…</summary>
 *       <div data-loume-panel>…</div>
 *     </details>
 *   </lo-disclosure>
 */
class LoumeDisclosure extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;

    this.details = this.querySelector('details');
    this.summary = this.details && this.details.querySelector('summary');
    this.panel = this.details && this.details.querySelector('[data-loume-panel]');
    if (!this.details || !this.summary || !this.panel) return;

    this.dataset.ready = 'true';
    this.animating = false;

    var self = this;
    this.summary.addEventListener('click', function (event) {
      self.onClick(event);
    });
  }

  get reducedMotion() {
    return Boolean(
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  onClick(event) {
    // Ohne Animation übernimmt der Browser das Umschalten selbst.
    if (this.reducedMotion) return;

    event.preventDefault();
    if (this.animating) return;

    if (this.details.open) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    this.animating = true;

    // Erst die Höhe auf 0 festschreiben, dann öffnen — sonst blitzt der
    // vollständige Text einen Frame lang auf.
    this.panel.style.maxHeight = '0px';
    this.details.open = true;

    var target = this.panel.scrollHeight;
    var self = this;

    this.afterTransition(function () {
      self.panel.style.maxHeight = '';
      self.animating = false;
    });

    window.requestAnimationFrame(function () {
      self.panel.style.maxHeight = target + 'px';
    });
  }

  collapse() {
    this.animating = true;

    var self = this;
    this.panel.style.maxHeight = this.panel.scrollHeight + 'px';
    // Reflow erzwingen, damit der Startwert wirklich anliegt.
    void this.panel.offsetHeight;

    this.afterTransition(function () {
      self.details.open = false;
      self.panel.style.maxHeight = '';
      self.animating = false;
    });

    this.panel.style.maxHeight = '0px';
  }

  /* Ruft fn genau einmal auf — beim Ende des Übergangs oder, falls der
     ausbleibt (z. B. weil die Höhe sich nicht ändert), nach 700ms. */
  afterTransition(fn) {
    var self = this;

    var done = function () {
      self.panel.removeEventListener('transitionend', onEnd);
      window.clearTimeout(self.timer);
      fn();
    };

    var onEnd = function (event) {
      if (event.target !== self.panel || event.propertyName !== 'max-height') return;
      done();
    };

    this.panel.addEventListener('transitionend', onEnd);
    this.timer = window.setTimeout(done, 700);
  }

  disconnectedCallback() {
    window.clearTimeout(this.timer);
  }
}

if (!customElements.get('lo-disclosure')) {
  customElements.define('lo-disclosure', LoumeDisclosure);
}
})();
